import { genRecaptchaToken, getOAuth2Url, navigateOAuth2, postDataBox } from '../../api';
import { apipe, clearStorage, debug, handleErrors, is, when } from '../../utils';

export const onOAuth2OrderHandler =
  ({ domain, utc_offset_min, source_context, recaptcha_site_key }) =>
  (provider, fields) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'autoEvent',
        eventAction: 'OAuth SOF',
        eventCategory: provider,
        eventLabel: 'Click',
      });
    }

    apipe(
      debug(postDataBox, 'oauth2: postDataBox'),
      when(
        is('data_box_key', 'recaptcha_action', 'recaptcha_site_key'),
        debug(genRecaptchaToken, 'oauth2: genRecaptchaToken'),
      ),
      when(
        is('data_box_key', 'captcha_token', 'policy_agree'),
        debug(getOAuth2Url, 'oauth2: getOAuth2Url'),
      ),
      when(is('auth_url'), debug(navigateOAuth2, 'oauth2: navigateOAuth2')),
      when(is('auth_url'), debug(clearStorage, 'oauth2: clearStorage')),
      debug(handleErrors, 'oauth2: handleErrors'),
    )({
      domain,
      provider,
      utc_offset_min,
      source_context,
      recaptcha_site_key,
      recaptcha_action: 'POST/users/oauth2/url/provider',
      ...fields,
    });
  };

export const onOAuth2LoginHandler =
  ({ domain, utc_offset_min, source_context, recaptcha_site_key }) =>
  (provider, values) => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'autoEvent',
        eventAction: 'OAuth Sign in',
        eventCategory: provider,
        eventLabel: 'Click',
      });
    }

    return apipe(
      when(
        is('recaptcha_action', 'recaptcha_site_key'),
        debug(genRecaptchaToken, 'OAuth2: genRecaptchaToken'),
      ),
      when(is('captcha_token', 'policy_agree'), debug(getOAuth2Url, 'OAuth2: getOAuth2Url')),
      when(is('auth_url'), debug(navigateOAuth2, 'OAuth2: navigateOAuth2')),
    )({
      ...values,
      domain,
      provider,
      utc_offset_min,
      source_context,
      policy_agree: true,
      recaptcha_action: 'POST/users/oauth2/url/provider',
      recaptcha_site_key,
    });
  };
